import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getAuthenticatedUser } from '../../../actions/auth';
import { useDispatch } from 'react-redux';
import { verifyTransaction } from '../../../actions/payments';
import { getUserDetails, refreshUserDetails } from '../../../actions/user';

// import './addMoney.css';

// {
// http://localhost:3000/user/add_money/verify?credentials=%7B%22amount%22%3A%221000%22%2C%22provider%22%3A%22monnify%22%2C%22transaction_reference%22%3A%22MNFY%7CPAYREF%7CTEST%7CGENERATED%7C1749703098410451483%22%7D
//     "success": true,
//     "message": "Payment initialization successful",
//     "data": {
//         "transaction_reference": "WF_684a506a617e5_1749700714"
//     }
// }

const AddMoneyVerify = () => {
  const hasRunRef = useRef(false);
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);

  // const refId = queryParams.get('credentials');
  const credentialsString = queryParams.get('credentials');

  let credentials = null;
  try {
    credentials = credentialsString ? JSON.parse(decodeURIComponent(credentialsString)) : null;
  } catch (error) {
    // console.error("Invalid credentials in URL", error);
  }

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const isPayloadEmpty = !credentials;
  const transactionRef = credentials?.transaction_reference || 'unknown';
  const sessionKey = `verified_${transactionRef}`;

  useEffect(() => {
    if (isPayloadEmpty) {
      navigate("/user/add_money", { replace: true });
      return;
    }
  }, [isPayloadEmpty, navigate]);  

  const triggerUserAuth = React.useCallback(async () => {
    // await getUserDetails(dispatch);
    await refreshUserDetails(dispatch);
  }, [dispatch]);


  const verifyingTransaction = async () => {

    setLoading(true);

    try {
      const response = await verifyTransaction(credentials); 
      const transactionInfo = response?.data?.data;
      if (['successful', 'success', 'completed'].includes(transactionInfo?.status)) {
        navigate(`/user/add_money/success`, { state: { amount: transactionInfo?.amount, currencyCode: transactionInfo?.wallet?.currency, status: 'successful' } });
      } 
      else if (transactionInfo?.status == 'failed'){
        navigate(`/user/add_money/failed`, { state: { amount: transactionInfo?.amount, currencyCode: transactionInfo?.wallet?.currency } });
      }
      else {
        navigate(`/user/add_money/success`, { state: { amount: transactionInfo?.amount, currencyCode: transactionInfo?.wallet?.currency, status: 'pending' } });
      } 

      triggerUserAuth();
    } catch (error) {
      // console.error('Error verifying transaction:', error);
      toast.error('Transaction verification failed. Please try again later.');

      setTimeout(() => {
        navigate(`/user/transactions`);
      }, 3000);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (!credentials) return;
    verifyingTransaction();
  }, []);

  return (
    <div className="container-fluid vh-100 d-flex align-items-start justify-content-center pt-5" style={{ backgroundColor: '#F7FCFF' }}>
      <div className="text-center">
        <div className="card shadow-lg border-0" style={{ minWidth: '400px', padding: '2rem' }}>
          <div className="card-body">
            <h2 className="card-title mb-5 text-primary fw-bold">
              Verifying Transaction
            </h2>
            
            <div className="mb-5">
              <div className="spinner" style={{
                width: '100px',
                height: '100px',
                border: '5px solid #e9ecef',
                borderTop: '5px solid #007bff',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite',
                margin: '0 auto'
              }}></div>
            </div>
            
            <p className="text-muted mb-3">
              Please wait while we process your transaction...
            </p>
            
            <small className="text-secondary">
              This may take a few moments
            </small>
          </div>
        </div>
      </div>
      
      {/* CSS Animation */}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        
        .card {
          transition: transform 0.2s ease-in-out;
        }
        
        .card:hover {
          transform: translateY(-2px);
        }
        
        .spinner {
          filter: drop-shadow(0 2px 4px rgba(0,123,255,0.3));
        }
      `}</style>
    </div>
  );
};

export default AddMoneyVerify;